import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaUndefinedDefinition } from './TypedDefinition'

export const SchemaUndefinedPlugin = createSchemaPlugin(
  'Schema.Undefined',
  SchemaUndefinedDefinition
)
